import BASEAPI from '@/util/BASEAPI';
import env from '@env';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

export async function creditEdit(retURL: string, cancelURL: string, redirectId: string, orderID: string) {
    let res = await BASEAPI.CreditController.creditUsingGET(orderID ? orderID : undefined, redirectId ? redirectId : undefined).catch(AxiosErrorHandler);
    if (isAxiosError(res)) {
        throw "" + res.data;
    }
    if (!res.data) {
        throw "内部エラー";
    }
    res.data.hiddenInput["RetURL"] = env.API_ORIGIN + retURL;
    res.data.hiddenInput["CancelURL"] = env.FRONT_ORIGIN + cancelURL;
    formSubmit(res.data);
}

export function formSubmit(formData: BASEAPI.FormData) {
    let form = document.createElement("form");
    form.action = formData.action!;
    form.method = formData.method!;
    form.enctype = formData.enctype!;
    if (!formData.hiddenInput) {
        return
    }

    for (const key in formData.hiddenInput) {
        let input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = formData.hiddenInput[key];
        form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
}